import clsx from 'clsx';
import { useContext, useEffect, useState } from 'react';
import { SearchDataContext } from '../../lib/search_data_context';

const DEFAULT_GUEST_COUNT = 2;
const MAX_GUESTS_COUNT = 25;
const MAX_CHILDREN_COUNT = 10;
const MAX_CHILDREN_AGE = 17;
const DEFAULT_CHILD_AGE = 8;

export const GuestsPopup = ({ id, open, onClose }) => {
  const { onChangeCountGuests, onChangeChildrenAges, onChangeWithPet, ...context } = useContext(SearchDataContext);

  const [countGuests, setCountGuests] = useState(context.countGuests ?? DEFAULT_GUEST_COUNT);
  const [childrenAges, setChildrenAges] = useState(context.childrenAges ?? []);
  const [withPet, setWithPet] = useState(context.withPet ?? false);

  const minusCountGuests = () => {
    if (countGuests > 1) {
      setCountGuests(countGuests - 1);
      onChangeCountGuests(countGuests - 1);
    }
  };

  const plusCountGuests = () => {
    if (countGuests < MAX_GUESTS_COUNT) {
      setCountGuests(countGuests + 1);
      onChangeCountGuests(countGuests + 1);
    }
  };

  const minusChildrenAges = () => {
    if (childrenAges.length > 0) {
      const newChildrenAges = childrenAges.slice(0, -1);
      setChildrenAges(newChildrenAges);
      onChangeChildrenAges(newChildrenAges);
    }
  };

  const plusChildrenAges = () => {
    if (childrenAges.length < MAX_CHILDREN_COUNT) {
      const newChildrenAges = [...childrenAges, DEFAULT_CHILD_AGE];
      setChildrenAges(newChildrenAges);
      onChangeChildrenAges(newChildrenAges);
    }
  };

  const handleSetChildAge = (childIndex, newValue) => {
    const newChildrenAges = childrenAges.map((oldValue, i) => (i === childIndex ? newValue : oldValue));
    setChildrenAges(newChildrenAges);
    onChangeChildrenAges(newChildrenAges);
  };

  const handleToggleWithPet = () => {
    setWithPet(!withPet);
    onChangeWithPet(!withPet);
  };

  useEffect(() => {
    if (context.countGuests == null) {
      onChangeCountGuests(countGuests);
    }

    if (context.childrenAges == null) {
      onChangeChildrenAges(childrenAges);
    }

    if (context.withPet == null) {
      onChangeWithPet(withPet);
    }
  }, []);

  return (
    <div className={'guest search-drop'} id={id} style={{ display: open ? 'block' : 'none' }}>
      <div className='guest-wrap'>
        <div className='guest-line'>
          <div className='guest-line__title'>Взрослые</div>

          <div className='guest-line__count'>
            <div
              className={clsx('less', 'guest-line__count-btn', countGuests <= 1 && 'guest-line__count-btn_disable')}
              onClick={minusCountGuests}
            >
              <svg width='16' height='2' viewBox='0 0 16 2' fill='none' xmlns='http://www.w3.org/2000/svg'>
                <path d='M1 1H15' stroke='#DADADA' strokeWidth='2' strokeLinecap='square' />
              </svg>
            </div>

            <div className='guest-line__count-numb'>{countGuests}</div>

            <div
              className={clsx(
                'more',
                'guest-line__count-btn',
                countGuests >= MAX_GUESTS_COUNT && 'guest-line__count-btn_disable'
              )}
              onClick={plusCountGuests}
            >
              <svg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
                <path d='M8 1V15' stroke='#00C853' strokeWidth='2' strokeLinecap='square' />
                <path d='M15 8H1' stroke='#00C853' strokeWidth='2' strokeLinecap='square' />
              </svg>
            </div>
          </div>
        </div>

        <div className='guest-line'>
          <div className='guest-line__title'>Дети</div>

          <div className='guest-line__count'>
            <div
              className={clsx(
                'less',
                'guest-line__count-btn',
                childrenAges.length === 0 && 'guest-line__count-btn_disable'
              )}
              onClick={minusChildrenAges}
            >
              <svg width='16' height='2' viewBox='0 0 16 2' fill='none' xmlns='http://www.w3.org/2000/svg'>
                <path d='M1 1H15' stroke='#DADADA' strokeWidth='2' strokeLinecap='square' />
              </svg>
            </div>

            <div className={'guest-line__count-numb'}>{childrenAges.length}</div>

            <div
              className={clsx(
                'more',
                'guest-line__count-btn',
                childrenAges.length >= MAX_CHILDREN_COUNT && 'guest-line__count-btn_disable'
              )}
              onClick={plusChildrenAges}
            >
              <svg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
                <path d='M8 1V15' stroke='#00C853' strokeWidth='2' strokeLinecap='square' />
                <path d='M15 8H1' stroke='#00C853' strokeWidth='2' strokeLinecap='square' />
              </svg>
            </div>
          </div>
        </div>

        <div className='guest-child' style={childrenAges.length ? {} : { display: 'none' }}>
          <div className='guest-child__title'>Возраст детей</div>

          <div className='guest-child__input'>
            {childrenAges.map((childAge, index) => (
              <input
                key={index}
                className={'guest-child__input-item'}
                value={childAge}
                type={'number'}
                min={1}
                max={MAX_CHILDREN_AGE}
                onChange={(e) => handleSetChildAge(index, e.target.value)}
                onKeyDown={(event) => event.preventDefault()}
              />
            ))}
          </div>
        </div>
      </div>

      <div className={'guest__with-pet-wrapper'}>
        <div className={'mdc-form-field'}>
          <div className='mdc-checkbox'>
            <input
              type={'checkbox'}
              name={'with_pet'}
              className={'mdc-checkbox__native-control with_pet_checkbox'}
              id={`${id}-with_pet`}
              checked={withPet}
              onChange={handleToggleWithPet}
            />
            <div className='mdc-checkbox__background'>
              <svg className='mdc-checkbox__checkmark' viewBox='0 0 24 24'>
                <path className='mdc-checkbox__checkmark-path' fill='none' d='M1.73,12.91 8.1,19.28 22.79,4.59' />
              </svg>
              <div className='mdc-checkbox__mixedmark'></div>
            </div>
          </div>
          <label htmlFor={`${id}-with_pet`}>Путешествую с питомцем</label>
        </div>
      </div>

      <div className={'guest__submit-wrapper'}>
        <a
          className={clsx(
            'button',
            'button_color_primary',
            'button_variant_outline',
            'button_type_label-only',
            'button_size_middle',
            'button--submit'
          )}
          onClick={onClose}
        >
          Применить
        </a>
      </div>
    </div>
  );
};
